import React, { useCallback, useContext, useEffect, useState } from "react";
import Aggrid from "../../framework/AgGrid";
import GlobalContext from "../../framework/GlobalContext";
import { getUserLogs } from "../../services/user-service";
import { rowDown, rowUp, selectRow } from "../../utils/gridUtils";
import c from "./UserLogs.module.css";
import { userLogsColDefs } from "./UserReportsConstants";

const UserLogs = ({ id, onEscape = () => {} }) => {
  const [rowData, setRowData] = useState([]);
  const [api, setApi] = useState(null);
  const { setCurrentComponent } = useContext(GlobalContext);
  const keyupListener = useCallback(
    (e) => {
      if (!api) return;
      const key = e.key.toLowerCase();
      const ctrlKey = e.ctrlKey;
      if (key === "arrowdown") {
        rowDown(api, ctrlKey);
        return;
      }
      if (key === "arrowup") {
        rowUp(api, ctrlKey);
        return;
      }
      if (key === "escape") {
        return onEscape();
      }
    },
    [api, onEscape]
  );
  useEffect(() => {
    if (id) {
      getUserLogs(`_id=${id}`).then((r) => setRowData(r));
    }
  }, [id]);
  useEffect(() => {
    setCurrentComponent("grid_user_logs");
  }, [setCurrentComponent]);
  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => document.removeEventListener("keyup", keyupListener, false);
  }, [keyupListener]);
  return (
    <div className={c["logs"]}>
      <Aggrid
        id="grid_user_logs"
        columnDefs={userLogsColDefs}
        rowData={rowData}
        onGridReady={(params) => {
          setApi(params.api);
          params.api.sizeColumnsToFit();
        }}
        onRowDataChanged={(params) => {
          selectRow(params.api, 0);
        }}
      />
    </div>
  );
};

export default UserLogs;
